/**
 * ======================================
 *       Instructions for Alert Bar
 * ======================================
 *
 * << Motivation >>
 * The purpose og this component is to create an
 * easy and unified way  to display alert bars
 * to users.
 *
 * << Structure >>
 * The component main parts are:
 * 1. The *directive*:
 *    Inserted into an html
 *    where the alert bar will be displayed.
 *
 * 2. The *config object*:
 *    Controls the type and the visibility
 *    of the alert.
 *
 * << How to use >>
 * 1. create _alertMsg_ object with alertFactory.service::create()
 *    The alert bar's type (ALERT_MSG_TYPE) is passed
 *    as argument to this method.
 *
 * 2. Insert the dircetive into an html and send the
 *    _alertMsg_ object as input.
 *
 *    e.g. <prm-alert-bar [alert-object]="ctrl.alertMsg"></prm-laert-bar>
 *
 * 3. In order to display the alert use the _alertMsg_:
 *    alertMsg.show(html_template).
 *    This method receives html template as an argumnet.
 *
 *    ** note that in "SIGNIN" type, show() is received
 *       translation code.
 *
 * 4. The alert bar can be hidden again by alertMsg.hide()
 *     or by other ways (e.g. Dismiss button)
 *
 *
 * 
 * @itamarc
 *
 */
 
 
import {IAlertMsg} from './alertMsg.interface';
import {Injectable} from 'ng-metadata/core';
import {GeneralAlertMsg} from './generalAlertMsg';


@Injectable()
export class AlertFactory {

	public create(type: ALERT_MSG_TYPE = ALERT_MSG_TYPE.GENERAL) : IAlertMsg {
		return new GeneralAlertMsg(type);
	}
}



export enum ALERT_MSG_TYPE {
	GENERAL,
	SIGNIN,
    REQUEST,
    SIMPLE,
    SIMPLE_WITHOUT_DISMISS,
    BROWSE_GAP
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/widgets/alerts/alertFactory.service.ts